import { useEffect } from "react";
import { useTranslation } from "@/i18n/useTranslation";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  url: string;
}

export function useSeo({ title, description, keywords, url }: SeoProps) {
  const { language } = useTranslation();

  useEffect(() => {
    document.title = title;

    const setMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? "property" : "name";
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute("content", content);
    };

    setMetaTag("description", description);
    if (keywords) setMetaTag("keywords", keywords);
    
    setMetaTag("og:title", title, true);
    setMetaTag("og:description", description, true);
    setMetaTag("og:url", url, true);
    setMetaTag("og:type", "website", true);
    setMetaTag("og:locale", language, true);
    setMetaTag("og:site_name", "CookieRobot", true);

    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag("twitter:title", title);
    setMetaTag("twitter:description", description);

    document.documentElement.lang = language;

  }, [title, description, keywords, url, language]);
}
